// src/services/api.js 
import axiosInstance from './BaseUrl';

// ----- Category API -----
export const getDeveloperList = async () => {
    const response = await axiosInstance.get('/developers/');
    return response.data;
};

export const getPropertyListNew = async (page = 1, pageSize = 12, sortBy = 'price_desc', category = '', type = '', budget = '', handover = '', locationSelect = '', developer = '', project = '', keywords = [],selectedLocation = '', salesStatus='', projectType='', unitType='', rooms='',facility='' ,community='', rentalGuarantee='', paymentPlan='', deliveryPlan='', minArea, maxArea, minPrice, maxPrice,downPayment, deliveryDate) => {
  let url = `/property/?page=${page}&page_size=${pageSize}&sort_by=${sortBy}&type=${type}&budget=${budget}&handover=${handover}&location_select=${locationSelect}&developer=${developer}&project=${project}&keywords=${keywords} &selected_location=${selectedLocation}&sales_status=${salesStatus} &project_type=${projectType} &unit_type=${unitType} &rooms=${rooms}&facility=${facility} &community_name=${community} &rental_guarantee=${rentalGuarantee} &payment_plan=${paymentPlan} &delivery_plan=${deliveryPlan} &min_area=${minArea} &max_area=${maxArea} &min_price=${minPrice} &max_price=${maxPrice} &down_payment=${downPayment } &delivery_date=${deliveryDate} `;
  if (category && category !== 'All') {
    url += `&category=${category}`;
  }
  const response = await axiosInstance.get(url);  
  return response.data;
};

export const getDeveloperDetail = async (slug) => {
  const response = await axiosInstance.get(`/developer-detail/${slug}/`)
  return response.data
}

export const getPropertyList = async (page = 1, pageSize = 8) => {
    const response = await axiosInstance.get(`/property/?page=${page}&page_size=${pageSize}`);
    return response.data;

};

export const getCommunityList = async (params = {}) => {
  const response = await axiosInstance.get('/communities/', params)
  return response.data
}


export const getCommunityDetail = async (slug, page = 1, pageSize = 12) => {
  const response = await axiosInstance.get(`/community-detail/${slug}/`, {
    params: { page, page_size: pageSize }, // Set page_size to 12
  });
  return response.data;
};



export const getPropertyDetail = async (slug) => {
  const response = await axiosInstance.get(`/property-detail/${slug}/`);
  return response.data;
};



// services/Api.js
export const getBlogList = async (page = 1, pageSize = 8) => {
  try {
    const response = await axiosInstance.get(
      `/blog/?page=${page}&page_size=${pageSize}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blog list:", error);
    return { success: false, data: { results: [], count: 0 }, message: null, error };
  }
};

 
 export const getBlogDetail = async (slug) => {
   try {
     const response = await axiosInstance.get(`/blog-detail/${slug}/`);
     return response.data;
   } catch (error) {
     console.error("Error fetching blog detail:", error);
     return { success: false, data: null, message: null, error };
   }
 };

export const getSearchFilterOptions = async () => {
  const response = await axiosInstance.get('/search-filter/');
  return response.data;
};

export const postSearchFilter = async (filters, page = 1, pageSize = 12) => {
  const response = await axiosInstance.post('/search-filter/', {
    ...filters,
    page,
    page_size: pageSize,
  });
  return response.data;
};

// export const postSearchFilter = async (filters) => {
//   const response = await axiosInstance.post('/search-filter/',filters);
//   return response.data;
// }

export const getProjectNames = async () => {
  const response = await axiosInstance.get('/property_names/');
  return response.data;
}

export const toggleSaveProperty = async (property_id) => {
  const response = await axiosInstance.post('/saved-properties/save/', {
    property_id
  });
  return response.data;
};

// Check if property is saved
export const checkPropertySaved = async (property_id) => {
  const response = await axiosInstance.get('/saved-properties/save/', {
    params: { property_id }
  });
  return response.data;
};

// src/services/api.js

export const postLead = async (leadData) => {
  try {
    const res = await axiosInstance.post('/leads/', leadData);
    return res.data;
  } catch (error) {
    console.error("Error posting lead:", error.response?.data || error.message);
    return { success: false, message: "Failed to submit lead", error: error.response?.data?.error };
  }
};

export const getPropertyCount = async () => {
  try {
    const response = await axiosInstance.get('/property_count/');
    return response.data;
  } catch (error) {
    console.error("Error fetching property count:", error);
    return { success: false, data: null, message: null, error };
  }
};

export const getallPropertiesFilterApi = async () => {
  try {
    const response = await axiosInstance.get('/property_all_filter/');
    return response.data;
  } catch (error) {
    console.error("Error fetching property count:", error);
    return { success: false, data: null, message: null, error };
  }
};



export class AuthService {
  static async login(credentials) {
    try {
      const response = await axiosInstance.post('/auth/login/', credentials)
      return response.data
    } catch (error) {
      throw error
    }
  }

  static storeTokens(tokens) {
    localStorage.setItem("accessToken", tokens.access)
    localStorage.setItem("refreshToken", tokens.refresh)
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${tokens.access}`
  }

  static storeUserData(userData) {
    localStorage.setItem("userData", JSON.stringify(userData))
  }

  static clearStorage() {
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")
    localStorage.removeItem("userData")
    delete axiosInstance.defaults.headers.common['Authorization']
  }
}

export class RegisterService {
  static async register(userData) {
    try {
      const response = await axiosInstance.post('/auth/register/', userData)
      return response.data
    } catch (error) {
      throw error
    }
  }

  static storeUserSession(data) {
    localStorage.setItem("accessToken", data.tokens.access)
    localStorage.setItem("refreshToken", data.tokens.refresh)
    
    if (data.user) {
      localStorage.setItem("userData", JSON.stringify(data.user))
    }
  }
}


export class ProfileService {
  static async getProfile() {
    try {
      const response = await axiosInstance.get('/auth/profile/')
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async updateProfile(profileData) {
    try {
      const response = await axiosInstance.put('/auth/profile/', profileData)
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async getReferralStats() {
    try {
      const response = await axiosInstance.get('/referrals/stats/')
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async getReferrals() {
    try {
      const response = await axiosInstance.get('/referrals/')
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async getReferralRewards() {
    try {
      const response = await axiosInstance.get('/referrals/rewards/')
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async getReferralCode() {
    try {
      const response = await axiosInstance.get('/referrals/code/')
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async getSavedProperty() {
    try {
      const response = await axiosInstance.get('/saved-properties/')
      return response.data
    } catch (error) {
      throw error
    }
  }

  static async toggleSaveProperty(property_id) {
    try {
      const response = await axiosInstance.post('/saved-properties/save/', property_id)
      return response.data
    } catch (error) {
      throw error
    }
  }


  static async getReferralData() {
    try {
      const [statsResponse, referralsResponse, rewardsResponse, codeResponse] = await Promise.all([
        this.getReferralStats(),
        this.getReferrals(),
        this.getReferralRewards(),
        this.getReferralCode()
      ])

      return {
        stats: statsResponse.success ? statsResponse.data : null,
        referrals: referralsResponse.success ? referralsResponse.data : [],
        rewards: rewardsResponse.success ? rewardsResponse.data : [],
        code: codeResponse.success ? codeResponse.data.code : ''
      }
    } catch (error) {
      throw error
    }
  }
}